import Vue from 'vue'
import to from 'await-to-js'
import buildClient from '@/api/client'
import getOrderByNumberQuery from '@/api/order-by-number'
import {
  itemTotal,
  shippingTotal,
  promotionTotal,
  promotionCode,
  taxLines,
  taxTotal,
  total,
} from '@/stores/order'

export default {
  namespaced: true,
  state: {
    ordersByOrderNumber: {},
  },
  mutations: {
    addOrder(state, order) {
      Vue.set(state.ordersByOrderNumber, order.number, order)
    },
  },
  actions: {
    async fetchOrderByNumber({ commit }, orderNumber) {
      const [error, response] = await to(buildClient().query(getOrderByNumberQuery(orderNumber)))
      if (error || !response.order) {
        throw new Error(`Failed fetching order for given number: ${orderNumber}`)
      }
      response.order.store = response.currentStore
      commit('addOrder', response.order)
    },
  },

  getters: {
    getOrderByNumber: state => orderNumber => state.ordersByOrderNumber[orderNumber],
    getShippingAddress: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.shippingAddress || {},
    getBillingAddress: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.billingAddress || {},
    getEmail: (state, getters) => orderNumber => getters.getOrderByNumber(orderNumber)?.email || '',
    getFirstname: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.shippingAddress?.firstname || '',
    getSelectedShippingMethod: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.shippingRates?.find(obj => obj.selected) || {},
    getItems: (state, getters) => orderNumber => getters.getOrderByNumber(orderNumber)?.items || [],
    getItemTotal: (state, getters) => orderNumber => itemTotal(getters.getItems(orderNumber)),
    getShippingTotal: (state, getters, rootState, rootGetters) => orderNumber =>
      shippingTotal(
        getters.getItems(orderNumber),
        rootGetters['store/shippingThreshold'],
        rootGetters['store/shippingCost'],
        getters.getOrderByNumber(orderNumber)?.shippingRates.find(obj => obj.selected)
      ),
    getPromotionTotal: (state, getters) => orderNumber =>
      promotionTotal(getters.getOrderByNumber(orderNumber)?.promotionAdjustment),
    getPromotionCode: (state, getters) => orderNumber =>
      promotionCode(getters.getOrderByNumber(orderNumber)?.promotionAdjustment),
    getTaxLines: (state, getters) => orderNumber =>
      taxLines(getters.getOrderByNumber(orderNumber)?.taxAdjustments),
    getTaxTotal: (state, getters) => orderNumber =>
      taxTotal(
        getters.getOrderByNumber(orderNumber)?.taxAdjustments,
        getters.getOrderByNumber(orderNumber)?.isTaxIncluded
      ),
    getTotal: (state, getters) => orderNumber =>
      total(
        getters.getItemTotal(orderNumber),
        getters.getShippingTotal(orderNumber),
        getters.getPromotionTotal(orderNumber),
        getters.getTaxTotal(orderNumber),
        getters.getOrderByNumber(orderNumber)?.isTaxIncluded
      ),
    getIsNewsletterSubscribed: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.isNewsletterSubscribed || false,
  },
}
